import type { ViewStyle } from "react-native";
import { getTokenValue, type SizeTokens } from "tamagui";

import { withAlpha } from "@medbillai/utils/color";

import type { RadiusTokensKeys } from "../themes/token-radius";

export const SHIMMER_DURATION_MS = 1400;

/** px, percentage, or a `$si` size token. */
export type SkeletonDimension = SizeTokens | ViewStyle["width"];

/** px or a `$br` radius token. */
export type SkeletonRadius = number | `$${RadiusTokensKeys}`;

/**
 * Decorative only (hidden from assistive tech): the region that swaps
 * skeleton↔content owns the announcement — set `aria-busy` on that wrapper.
 */
export type SkeletonShimmerProps = {
  width?: SkeletonDimension;
  /** Defaults to filling the parent — size the container instead when possible. */
  height?: SkeletonDimension;
  radius?: SkeletonRadius;
};

export function resolveShimmerStyle(radius: SkeletonRadius) {
  const rest = String(getTokenValue("$surface0", "color"));
  return {
    rest,
    highlight: String(getTokenValue("$surface1", "color")),
    restTransparent: withAlpha(rest, 0),
    radiusPx:
      typeof radius === "number" ? radius : getTokenValue(radius, "radius"),
  };
}
